import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MPCMap = _resolveComponent("MPCMap")!
  const _component_MPFDefault = _resolveComponent("MPFDefault")!
  const _component_MPHDefault = _resolveComponent("MPHDefault")!
  const _component_MPCClusterConfig = _resolveComponent("MPCClusterConfig")!
  const _component_MPFClusterConfig = _resolveComponent("MPFClusterConfig")!
  const _component_MPCAddNodePool = _resolveComponent("MPCAddNodePool")!
  const _component_ModalTunnel = _resolveComponent("ModalTunnel")!

  return (_openBlock(), _createBlock(_component_ModalTunnel, {
    visible: _ctx.visible,
    loading: _ctx.loading,
    closeOnExternalClick: false,
    maxHeightContent: 
      _ctx.currentPageKey === _ctx.pageKeys.MAP
        ? 'calc(100vh - 73px)'
        : 'calc(100vh - 315px)'
    ,
    width: _ctx.currentPageKey === _ctx.pageKeys.MAP ? 'calc(100vw - 46px)' : undefined,
    nbPages: _ctx.nbTunnelPages,
    displayNavigation: false,
    ref: "refTunnel"
  }, {
    [`content-${_ctx.pages.MAP.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCMap, {
        createMode: _ctx.creating && _ctx.visible,
        showMap: _ctx.visible,
        location: _ctx.selectedLocation,
        "onUpdate:location": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocation) = $event)),
          _ctx.resetNodePoolList
        ],
        criticality: _ctx.criticality,
        "onUpdate:criticality": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.criticality) = $event)),
        provider: _ctx.providerIdSelected,
        "onUpdate:provider": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.providerIdSelected) = $event)),
        requireGPU: _ctx.requireGPU,
        "onUpdate:requireGPU": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requireGPU) = $event))
      }, null, 8, ["createMode", "showMap", "location", "criticality", "provider", "requireGPU", "onUpdate:location"])
    ]),
    [`footer-${_ctx.pages.MAP.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFDefault, {
        previousLabel: _ctx.pages.MAP.previousLabel,
        nextLabel: _ctx.pages.MAP.nextLabel,
        disableNextButton: !_ctx.selectedLocation,
        onPrevious: _ctx.askCloseConfirmation,
        onNext: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.CLUSTER_CONFIG)))
      }, null, 8, ["previousLabel", "nextLabel", "disableNextButton", "onPrevious"])
    ]),
    [`header-${_ctx.pages.CLUSTER_CONFIG.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPHDefault, {
        header: _ctx.name,
        "onUpdate:header": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
        headerEditable: true,
        closeButton: true,
        headerEditCall: _ctx.headerEditCall,
        onClose: _ctx.askCloseConfirmation
      }, null, 8, ["header", "headerEditCall", "onClose"])
    ]),
    [`content-${_ctx.pages.CLUSTER_CONFIG.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCClusterConfig, {
        provider: _ctx.providerIdSelected,
        providerLabel: _ctx.providerLabel,
        location: _ctx.selectedLocation,
        nodePoolList: _ctx.nodePoolList,
        nbMasterNodes: {
          min: _ctx.masterNodes.min?.length ?? 0,
          max: _ctx.masterNodes.max?.length ?? 0,
        },
        errorMsg: 
          _ctx.nodePoolList.length && _ctx.notEnoughtNodes
            ? `This cluster needs a minimum of ${_ctx.minWorkerNodeRequirements} worker node${
                _ctx.minWorkerNodeRequirements > 1 ? 's' : ''
              }`
            : ''
        ,
        hasFransysAccount: _ctx.canCurrentProviderUseFransysAccount,
        customerAccounts: _ctx.customerProviderAccounts,
        selectedInfrastructureProviderAccountId: 
          _ctx.selectedInfrastructureProviderAccountId
        ,
        "onUpdate:selectedInfrastructureProviderAccountId": _cache[6] || (_cache[6] = ($event: any) => ((
          _ctx.selectedInfrastructureProviderAccountId
        ) = $event)),
        isAutoPilot: _ctx.isAutoPilot,
        "onUpdate:isAutoPilot": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isAutoPilot) = $event)),
        safety: _ctx.safety,
        "onUpdate:safety": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.safety) = $event)),
        maxBudget: _ctx.maxBudget,
        "onUpdate:maxBudget": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.maxBudget) = $event)),
        onConnectAccount: _ctx.goToConnectedServices,
        onGoToAddNodePool: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.ADD_NODE_POOL))),
        onDeleteNodePool: _ctx.deleteNodePool
      }, null, 8, ["provider", "providerLabel", "location", "nodePoolList", "nbMasterNodes", "errorMsg", "hasFransysAccount", "customerAccounts", "selectedInfrastructureProviderAccountId", "isAutoPilot", "safety", "maxBudget", "onConnectAccount", "onDeleteNodePool"])
    ]),
    [`footer-${_ctx.pages.CLUSTER_CONFIG.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFClusterConfig, {
        isAutoPilot: _ctx.isAutoPilot,
        provider: _ctx.providerIdSelected,
        location: _ctx.selectedLocation,
        nodePoolList: _ctx.nodePoolList,
        masterNodes: _ctx.masterNodes,
        nbNodes: _ctx.nbNodes,
        publishState: _ctx.buttonStatePublish,
        publishDisabled: 
          _ctx.disableBtnPublish || _ctx.notEnoughtNodes || !_ctx.hasAnyAccountOption || !_ctx.selectedLocation?.id
        ,
        publishLoading: _ctx.saving,
        onPublish: _cache[11] || (_cache[11] = ($event: any) => (_ctx.accept(true))),
        onPrevious: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.MAP)))
      }, null, 8, ["isAutoPilot", "provider", "location", "nodePoolList", "masterNodes", "nbNodes", "publishState", "publishDisabled", "publishLoading"])
    ]),
    [`header-${_ctx.pages.ADD_NODE_POOL.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPHDefault, {
        header: _ctx.pages.ADD_NODE_POOL.header,
        prevButton: true,
        closeButton: false,
        onPrev: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.CLUSTER_CONFIG)))
      }, null, 8, ["header"])
    ]),
    [`content-${_ctx.pages.ADD_NODE_POOL.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCAddNodePool, {
        provider: _ctx.providerIdSelected,
        location: _ctx.selectedLocation,
        onTypologySelected: _ctx.onDraftTypologySelected
      }, null, 8, ["provider", "location", "onTypologySelected"])
    ]),
    [`footer-${_ctx.pages.ADD_NODE_POOL.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFDefault, {
        disableNextButton: !_ctx.draftTypology,
        previousLabel: _ctx.pages.ADD_NODE_POOL.previousLabel,
        nextLabel: _ctx.pages.ADD_NODE_POOL.nextLabel,
        onPrevious: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.CLUSTER_CONFIG))),
        onNext: _ctx.createNodePool
      }, null, 8, ["disableNextButton", "previousLabel", "nextLabel", "onNext"])
    ]),
    _: 2
  }, 1032, ["visible", "loading", "maxHeightContent", "width", "nbPages"]))
}